import Content from '@/components/client/common/Content'

import TaskWall from '@/components/client/TaskWall'
import WorkBench from '@/components/client/WorkBench'
import MessageCenter from '@/components/client/MessageCenter'
import BalanceCenter from '@/components/client/BalanceCenter'
import PaymentRecord from '@/components/client/PaymentRecord'
import ChannelCredit from '@/components/client/ChannelCredit'
import AccountInfo from '@/components/client/AccountInfo'
import ShopAddress from '@/components/client/ShopAddress'
import ExpensesRecord from '@/components/client/ExpensesRecord'
import MyOrder from '@/components/client/MyOrder'
import OrderDetails from '@/components/client/OrderDetails'
import CommonProblem from '@/components/client/CommonProblem'
import ChangePassword from '@/components/client/ChangePassword'
import PromoteData from '@/components/client/PromoteData'
import IntelAnalysis from '@/components/client/IntelAnalysis'
import Feedback from '@/components/client/Feedback'
import BaiList from '@/components/client/BaiList'
import InfoList from '@/components/client/InfoList'
import CpcDailyStatement from '@/components/client/CpcDailyStatement'
import CpcReceiveList from '@/components/client/CpcReceiveList'
import ShoppingMall from '@/components/client/ShoppingMall'
import Resource from '@/components/client/Resource'
import DailyStatement from '@/components/client/DailyStatement'
import ReceiveList from '@/components/client/ReceiveList'
import ShoppingDetails from '@/components/client/ShoppingDetails'
import SucceedDetails from '@/components/client/SucceedDetails'
import ConfirmOrder from '@/components/client/ConfirmOrder'
import Messages from '@/components/Message'
import Datadispose from '@/components/client/crm/Datadispose'
import EccrmSetting from '@/components/client/ec/EccrmSetting'
import LxcrmSetting from '@/components/client/lxcrm/LxcrmSetting'
// import LxcrmDispose from '@/components/client/lxcrm/LxcrmDispose' // 已整合到一个组件Datadispose,稳定后可删除
import XbbcrmSetting from '@/components/client/xbb/XbbcrmSetting'
import HbycrmSetting from '@/components/client/hby/HbySetting'
// import XbbcrmDispose from '@/components/client/xbb/XbbcrmDispose' // 已整合到一个组件Datadispose,稳定后可删除

const routes = {
  path: 'admin',
  component: Content,
  children: [
    {
      path: '/task-wall',
      name: 'task-wall',
      component: TaskWall
    },
    {
      path: '/work-bench',
      name: 'work-bench',
      component: WorkBench
    },
    {
      path: '/message-center',
      name: 'message-center',
      component: MessageCenter
    },
    {
      path: '/balance-center',
      name: 'balance-center',
      component: BalanceCenter
    },
    {
      path: '/payment-record',
      name: 'payment-record',
      component: PaymentRecord
    }, {
      path: '/channel-credit',
      name: 'channel-credit',
      component: ChannelCredit
    }, {
      path: '/account-info',
      name: 'account-info',
      component: AccountInfo
    }, {
      path: '/shop-address',
      name: 'shop-address',
      component: ShopAddress
    }, {
      path: '/expenses-record',
      name: 'expenses-record',
      component: ExpensesRecord
    }, {
      path: '/my-order',
      name: 'my-order',
      component: MyOrder
    }, {
      path: ':id/order-details',
      name: 'order-details',
      component: OrderDetails
    }, {
      path: '/common-problem',
      name: 'common-problem',
      component: CommonProblem
    }, {
      path: '/change-password',
      name: 'change-password',
      component: ChangePassword
    }, {
      path: '/promote-data',
      name: 'promote-data',
      component: PromoteData
    }, {
      path: '/intel-analysis',
      name: 'intel-analysis',
      component: IntelAnalysis
    }, {
      path: '/feedback',
      name: 'feedback',
      component: Feedback
    }, {
      path: '/bai-list',
      name: 'bai-list',
      component: BaiList
    }, {
      path: '/info-list',
      name: 'info-list',
      component: InfoList
    }, {
      path: '/cpc-daily-statement',
      name: 'cpc-daily-statement',
      component: CpcDailyStatement
    }, {
      path: '/cpc-receive-list',
      name: 'cpc-receive-list',
      component: CpcReceiveList
    }, {
      path: '/resource',
      name: 'resource',
      component: Resource
    }, {
      path: '/daily-statement',
      name: 'daily-statement',
      component: DailyStatement
    }, {
      path: '/receive-list',
      name: 'receive-list',
      component: ReceiveList
    }, {
      path: '/shopping-mall',
      name: 'shopping-mall',
      component: ShoppingMall
    }, {
      path: '/shopping-details',
      name: 'shopping-details',
      component: ShoppingDetails
    }, {
      path: '/succeed-details',
      name: 'succeed-details',
      component: SucceedDetails
    }, {
      path: '/confirm-order:id:num',
      name: 'confirm-order',
      component: ConfirmOrder
    }, {
      path: '/messages',
      name: 'messages',
      component: Messages
    }, {
      path: '/:type/data-dispose',
      name: 'data-dispose',
      component: Datadispose
    }, {
      path: '/ec-setting',
      name: 'ec-setting',
      component: EccrmSetting
    }, {
      path: '/lxcrm-setting',
      name: 'lxcrm-setting',
      component: LxcrmSetting
    }, {
      path: '/xbbcrm-setting',
      name: 'xbbcrm-setting',
      component: XbbcrmSetting
    }, {
      path: '/hby-setting',
      name: 'hby-setting',
      component: HbycrmSetting
    }
    // {
    //   path: '/xbbcrm-dispose',
    //   name: 'xbbcrm-dispose',
    //   component: XbbcrmDispose
    // }, {
    //   path: '/lxcrm-dispose',
    //   name: 'lxcrm-dispose',
    //   component: LxcrmDispose
    // }
  ]
}
export default routes



// WEBPACK FOOTER //
// ./src/router/client/index.js